import React, { useEffect, useState } from 'react';
import css from './index.module.scss';
import { useLang } from '@/i18n';
import EcoImg from 'eco-design/base/eco-img';
import { useProductStore } from '../../../../ProductProvider';

interface Props {}

const F: React.FC<Props> = ({}) => {
    const { t } = useLang('theProduct.F');
    const [load, setLoad] = useState(false);
    const [enter, setEnter] = useState(false);
    const { productInfo } = useProductStore();

    useEffect(() => {
        if (typeof window !== 'undefined') {
            const scenes: any[] = [];
            scenes.push(
                AniContainer.create({
                    triggerElement: '.rapid-mag-C',
                    triggerHook: 1,
                    onEnter: () => setLoad(true),
                }),
            );
            scenes.push(
                AniContainer.create({
                    triggerElement: '.rapid-mag-F .card1 .bars',
                    triggerHook: 1,
                    offset: 120,
                    duration: '150%',
                    onEnter: () => setEnter(true),
                    onLeave: () => setEnter(false),
                }),
            );
            if (window.innerWidth > 1024) {
                scenes.push(
                    AniContainer.create({
                        triggerElement: '.rapid-mag-F',
                        triggerHook: 1,
                        offset: '120%',
                        duration: '10%',
                        syncFromTo: [
                            ['.rapid-mag-F .card1', { opacity: 1 }, { opacity: 0 }],
                            ['.rapid-mag-F .card2', { opacity: 0 }, { opacity: 1 }],
                        ],
                    }),
                );
            }
            return () => scenes.forEach((scene) => scene.destroy());
        }
    }, [productInfo]);

    return (
        <section
            id="rapid-mag-F"
            className={`rapid-mag-F ${css.section} GtmModuleData-section`}
            data-section-id={'rapid-mag-F'}
            data-section-title={t('title')}
        >
            <div className="sticky">
                <div className="card card1">
                    <div className="info">
                        <div className="icon">
                            <EcoImg pc="https://websiteoss.ecoflow.com/figma-uploads/1762479852687-ibq55f-compressed-Frame%201000009055.jpg" />
                        </div>
                        <p className="title">{t('1_title')}</p>
                        <p className="subtitle">{t('1_subtitle')}</p>
                        <p className="desc">{t('1_desc')}</p>
                        <div className={`bars${enter ? ' enter' : ''}`}>
                            <div className="bar bar1">
                                <span className="text1">{t('1_bar1_text1')}</span>
                                <p className="line"></p>
                                <span className="text2">{t('1_bar1_text2')}</span>
                            </div>
                            <div className="bar bar2">
                                <span className="text1">{t('1_bar2_text1')}</span>
                                <p className="line"></p>
                                <span className="text2">{t('1_bar2_text2')}</span>
                            </div>
                        </div>
                    </div>
                    <div className="video">
                        {load && (
                            <video
                                src="https://websiteoss.ecoflow.com/upload/video/1762847696496/f1.mp4"
                                muted
                                autoPlay
                                loop
                                width="100%"
                                height="100%"
                                playsInline
                                poster=""
                                preload="auto"
                            />
                        )}
                    </div>
                </div>
                <div className="card card2">
                    <div className="info">
                        <div className="icon">
                            <EcoImg pc="https://websiteoss.ecoflow.com/figma-uploads/1762479852687-ibq55f-compressed-Frame%201000009055.jpg" />
                        </div>
                        <p className="title">{t('2_title')}</p>
                        <p className="subtitle">{t('2_subtitle')}</p>
                        <p className="desc">{t('2_desc')}</p>
                    </div>
                    <div className="video">
                        {load && (
                            <video
                                src="https://websiteoss.ecoflow.com/upload/video/1762847696803/f2.mp4"
                                muted
                                autoPlay
                                loop
                                width="100%"
                                height="100%"
                                playsInline
                                poster=""
                                preload="auto"
                            />
                        )}
                    </div>
                </div>
            </div>
        </section>
    );
};
export default F;
